module.exports = __webpack_public_path__ + "static/media/01-_DSC8994.6cd692ed.jpg";